import type { FC, ReactNode } from 'react'
import { Icon, type IconName } from './Icon.js'

export type NoticeKind = 'info' | 'warn' | 'bad' | 'ok'

const GLYPH: Record<NoticeKind, IconName> = {
  info: 'info',
  warn: 'warn',
  bad: 'warn',
  ok: 'check',
}

export interface NoticeProps {
  kind?: NoticeKind
  children?: ReactNode
}

export const Notice: FC<NoticeProps> = ({ kind = 'info', children }) => (
  <div className={`notice notice--${kind}`} role={kind === 'bad' ? 'alert' : 'status'}>
    <span className="notice__icon">
      <Icon name={GLYPH[kind]} size={19} />
    </span>
    <div className="notice__body">{children}</div>
  </div>
)
